import { h, Component } from 'preact';

//import FontAwesomeIcon from './fontAwesomeIcon.js';
//import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import ContractorPhoneMumber from './contractorPhoneNumber.js';
//import DesktopCallToAction from './desktopCallToAction.js';

import style from '../../style/contractor.sass';
import ctaStyle from '../../style/desktopCallToAction.sass';

const getContractorSpotlightStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      contractorStyle: style.contractor,
      contractorHeaderStyle: style.contractorHeader,
      contractorListLinkStyle: style.contractorListLink,
      contractorNameStyle: style.contractorName,
      contractorFormLinkContainerStyle: style.contractorFormLinkContainer,
      contractorFormLinkStyle: style.contractorFormLink
    };
  }
  if(brand === 'ruud'){
    return {
      contractorStyle: style.contractorRuud,
      contractorHeaderStyle: style.contractorHeaderRuud,
      contractorListLinkStyle: style.contractorListLinkRuud,
      contractorNameStyle: style.contractorNameRuud,
      contractorFormLinkContainerStyle: style.contractorFormLinkContainerRuud,
      contractorFormLinkStyle: style.contractorFormLinkRuud
    };
  }
  if(brand === 'friedrich'){
    return {
      contractorStyle: style.contractorFriedrich,
      contractorHeaderStyle: style.contractorHeaderFriedrich,
      contractorListLinkStyle: style.contractorListLinkFriedrich,
      contractorNameStyle: style.contractorNameFriedrich,
      contractorFormLinkContainerStyle: style.contractorFormLinkContainerFriedrich,
      contractorFormLinkStyle: style.contractorFormLinkFriedrich
    };
  }
  return {
    contractorStyle: style.contractor,
    contractorHeaderStyle: style.contractorHeader,
    contractorListLinkStyle: style.contractorListLink,
    contractorNameStyle: style.contractorName,
    contractorFormLinkContainerStyle: style.contractorFormLinkContainer,
    contractorFormLinkStyle: style.contractorFormLink
  };
};

const getContractorStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      borderStyle: style.border,
      innerStyle: style.inner,
      innerInnerStyle: style.innerInner,
      innerImageContainerStyle: style.innerImageContainer,
      innerImageStyle: style.innerImage,
      bubbleBorderStyle: style.bubbleBorder,
      bubbleInnerStyle: style.bubbleInner
    };
  }
  if(brand === 'ruud'){
    return {
      borderStyle: style.borderRuud,
      innerStyle: style.innerRuud,
      innerInnerStyle: style.innerInnerRuud,
      innerImageContainerStyle: style.innerImageContainerRuud,
      innerImageStyle: style.innerImageRuud,
      bubbleBorderStyle: style.bubbleBorderRuud,
      bubbleInnerStyle: style.bubbleInnerRuud
    };
  }
  if(brand === 'friedrich'){
    return {
      borderStyle: style.borderFriedrich,
      innerStyle: style.innerFriedrich,
      innerInnerStyle: style.innerInnerFriedrich,
      innerImageContainerStyle: style.innerImageContainerFriedrich,
      innerImageStyle: style.innerImageFriedrich,
      bubbleBorderStyle: style.bubbleBorderFriedrich,
      bubbleInnerStyle: style.bubbleInnerFriedrich
    };
  }
  return {
    borderStyle: style.border,
    innerStyle: style.inner,
    innerInnerStyle: style.innerInner,
    innerImageContainerStyle: style.innerImageContainer,
    innerImageStyle: style.innerImage,
    bubbleBorderStyle: style.bubbleBorder,
    bubbleInnerStyle: style.bubbleInner
  };
};

const getContractorContainerStyleClassNames = (brand, campaignType) => {
  const classNames = [style.container];
  if(brand === 'friedrich'){
    classNames.push(style.containerFriedrich);
  }
  if(campaignType === 'repair'){
    if(brand === 'ruud'){
      classNames.push(style.ruudRepair);
    }else{
      classNames.push(style.repair);
    }
  }
  return classNames;
}

const getContractorBackgroundImageUrl = (brand) => {
  if(brand === 'rheem'){
    return 'assets/images/rheem/rheem_contractor_background.jpg';
  }
  if(brand === 'ruud'){
    return 'assets/images/ruud/ruud_contractor_background.jpg';
  }
  if(brand === 'friedrich'){
    return 'assets/images/friedrich/friedrich_contractor_background.png';
  }
  return 'assets/images/rheem/rheem_contractor_background.jpg';
}

const StaticDesktopCallToAction = props => {
  return (
    <div className={ctaStyle.container}>
      <div className={ctaStyle.offerStatic} onClick={props.onContractorListLinkClick}>
        SCHEDULE YOUR
        <span className={ctaStyle.offerFree}>FREE</span>
        IN-HOME ESTIMATE TODAY!
      </div>
    </div>
  );
};

const ContractorSpotlight = props => {
  const classNames = getContractorSpotlightStyleClassNames(props.brand);
  return (
    <div className={classNames.contractorStyle}>
      <div className={classNames.contractorHeaderStyle}>YOUR LOCAL PRO PARTNER</div>
      <div className={classNames.contractorNameStyle}>{props.contractor.name.toUpperCase()}</div>
      <ContractorPhoneMumber {...props} contractor={props.contractor} />
      <div className={classNames.contractorFormLinkContainerStyle}>
        <button onClick={(e)=>{
          e.preventDefault();
          props.showForm(props.contractor);
        }} className={classNames.contractorFormLinkStyle}>
          SCHEDULE NOW
        </button>
      </div>
      <div className={classNames.contractorListLinkStyle}>
        <a href="" onClick={props.onContractorListLinkClick}>See below for full list of <br />Pro Partners in your area</a>
      </div>
    </div>
  );
};

//<FontAwesomeIcon icon={faEdit} /> &nbsp;

export default class Contractor extends Component {
  constructor(props) {
    super(props);
  }
  render(props, state) {
    const contractor = Array.isArray(props.contractors)?props.contractors[0]:null;
    if(!contractor){
      return null;
    }
    const classNames = getContractorStyleClassNames(props.brand);
    const containerClassNames = getContractorContainerStyleClassNames(props.brand, props.campaignType);
    const backgroundImageUrl = getContractorBackgroundImageUrl(props.brand);

    return (
      <div id="contractor" className={containerClassNames.join(' ')}>
        <div className={style.outline}>
          <div className={classNames.borderStyle}>
            <div className={classNames.innerStyle}>
              <div className={classNames.innerInnerStyle}>
                <div className={classNames.innerImageContainerStyle}>
                  <img className={classNames.innerImageStyle} src={backgroundImageUrl} />
                </div>
              </div>
            </div>
          </div>
          <div className={classNames.bubbleBorderStyle}></div>
          <div className={classNames.bubbleInnerStyle}>
            <StaticDesktopCallToAction {...props} />
          </div>
          <ContractorSpotlight  {...props} contractor={contractor} />
        </div>
      </div>
    );
  }
}
//<DesktopCallToAction {...props} contractor={contractor} />